import { Stack, Typography } from '@mui/material';
import { useFeatureEnabledForConfig } from 'api/configurations';
import useIsAuditEnabled from 'hooks/useIsAuditEnabled';
import React from 'react';
import { S4Feature } from 'types/api';
import AuditBarButton from './AuditBarButton';
import SSOMappingBarButton from './SSOMappingBarButton';
import SSOTestingBarButton from './SSOTestingBarButton';

const AdvancedSection: React.FC = () => {
	const { enabled: ssoEnabled } = useFeatureEnabledForConfig(S4Feature.Sso);
	// The audit log also covers SCIM, so it stays reachable in a SCIM-only suite.
	const { enabled: auditEnabled } = useIsAuditEnabled();

	if (!ssoEnabled && !auditEnabled) {
		return null;
	}

	return (
		// Title and rows are siblings at 24, matching the Advanced node.
		<Stack gap={3}>
			<Typography variant="h3">{intl.tr('home.advancedTitle')}</Typography>
			{ssoEnabled && (
				<>
					<SSOMappingBarButton />
					<SSOTestingBarButton />
				</>
			)}
			{auditEnabled && <AuditBarButton />}
		</Stack>
	);
};

export default AdvancedSection;
